// src/utils/dateFormatter.ts
export function formatNorwegianDate(dateString: string): string {
  const date = new Date(dateString)
  const formatter = new Intl.DateTimeFormat('no-NO', {
    day: '2-digit', // This ensures leading zeros
    month: 'short',
  })
  return formatter.format(date).replace('.', '').toLowerCase()
}

export function formatDateRange(departureDate: string, returnDate?: string): string {
  const departure = new Date(departureDate)
  const returnD = returnDate ? new Date(returnDate) : null

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
  }

  if (returnD && departure.getFullYear() !== returnD.getFullYear()) {
    options.year = 'numeric'
  }

  const departureFormatter = new Intl.DateTimeFormat('no-NO', options)
  const returnFormatter = new Intl.DateTimeFormat('no-NO', options)

  const formattedDeparture = departureFormatter.format(departure)
  if (!returnD) {
    return formattedDeparture.toLowerCase()
  }

  const formattedReturn = returnFormatter.format(returnD)
  const separator = '–'

  if (
    departure.getMonth() === returnD.getMonth() &&
    departure.getFullYear() === returnD.getFullYear()
  ) {
    // Add leading zeros to dates and keep month name lowercase
    const monthName = new Intl.DateTimeFormat('no-NO', { month: 'short' })
      .format(departure)
      .toLowerCase()
    const departureDay = departure.getDate().toString().padStart(2, '0')
    const returnDay = returnD.getDate().toString().padStart(2, '0')
    return `${departureDay}.${separator}${returnDay}. ${monthName}`
  } else {
    return `${formattedDeparture.toLowerCase()} ${separator} ${formattedReturn.toLowerCase()}`
  }
}

export function formatShortNorwegianDate(dateString: string): string {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, '0')
  const monthName = new Intl.DateTimeFormat('no-NO', { month: 'short' }).format(date).toLowerCase()
  return `${day}. ${monthName}`
}

export function formatTime(timestamp: string): string {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  const hours = date.getHours().toString().replace(/^0/, '') // Keep this as is - hours without leading zero
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export function formatDate(dateTime: string | undefined): string {
  if (!dateTime) return ''
  const date = new Date(dateTime)
  const formatter = new Intl.DateTimeFormat('no-NO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  return formatter.format(date)
}
